import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=66b28c2a&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=js"
export * from "./previewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b28c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b28c2a')) {
      api.createRecord('66b28c2a', component.options)
    } else {
      api.reload('66b28c2a', component.options)
    }
    module.hot.accept("./previewDialog.vue?vue&type=template&id=66b28c2a&scoped=true", function () {
      api.rerender('66b28c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/devise/previewDialog.vue"
export default component.exports